import axios from 'axios';

const emailsStore = {
  state: {
    emails: [],
    limit: 5,
    lastKey: null,
    loading: false,
    isSearched: false,
  },

  mutations: {
    setEmails(state, res) {
      state.emails = res;
      // state.lastKey = res.lastKey;
      state.loading = false;
      // state.isSearched = res.forceUpdate;
    },

    deleteEmail(state, id) {
      state.emails = state.emails.filter(email => email.id !== id);
      state.loading = false;
    },

    setLoading(state, value) {
      state.loading = value;
    },

    setLimit(state, value) {
      state.limit = value;
    },
  },

  getters: {
    getEmails: state => state.emails,
  },

  actions: {
    async getEmails(context) {
      try {
        const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
        const options = {
          headers: {
            Authorization: jwtToken,
          },
          params: {},
        };
        // let { limit, lastKey, emails, isSearched } = context.state.emailStore;

        // if (data) {
        //   if (!data.search) {
        //     if (data.rowsPerPage) {
        //       limit = (data.rowsPerPage + 1);
        //       context.commit('setLimit', limit);
        //     }
        //     // if back action
        //     if (limit * data.page < emails.length) {
        //       return;
        //     }
        //     // if we loaded whole items
        //     if (emails.length && !lastKey && !isSearched) {
        //       return;
        //     }

        //     options.params = { limit, lastKey };
        //   } else {
        //     options.params = { search: data.search };
        //   }
        // }

        context.commit('setLoading', true);

        const res = await axios.get(`${window.BASE_API.EMAIL}/emails`, options)
          .then(response => response.data);

        // res.forceUpdate = !!data.search;

        context.commit('setEmails', res);
        context.commit('setLoading', false);
      } catch (err) {
        console.error(err);
      }
    },

    putEmail(context, data) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .post(`${window.BASE_API.EMAIL}/emails`, data, options)
        .then(() => {
          context.dispatch('getEmails');
          context.commit('setLoading', false);
        })
        .catch(() => {
          context.commit('setLoading', false);
        });
    },

    deleteEmail(context, id) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .delete(`${window.BASE_API.EMAIL}/emails/${id}`, options)
        .then(() => {
          context.commit('deleteEmail', id);
          context.commit('setLoading', false);
        });
    },

    getEmailDetail(context, id) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .get(`${window.BASE_API.EMAIL}/emails/${id}`, options)
        .then(({ data }) => {
          context.commit('setLoading', false);

          return data;
        })
        .catch(err => err);
    },
  },
};

export default emailsStore;



// WEBPACK FOOTER //
// ./src/store/emails/emailsStore.js